import { render, staticRenderFns } from "./SetField.vue?vue&type=template&id=bca08848&scoped=true&"
import script from "./SetField.vue?vue&type=script&lang=js&"
export * from "./SetField.vue?vue&type=script&lang=js&"
import style0 from "./SetField.vue?vue&type=style&index=0&id=bca08848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca08848",
  null
  
)

export default component.exports